import React, { useEffect } from "react";
import {
  changeUserAppointmentStatus,
  getUserAppointments,
} from "../../redux/Actions/UserAppointmentActions";
import DeleteModal from "../Modal/DeleteModal";
import { connect } from "react-redux";
import { getOverview } from "../../redux/Actions/OverviewActions";
import { useHistory } from "react-router";
import { useOverviewTypeContext } from "../../contexts/OverviewTypeContext";

const CompleteAppointment = (props) => {
  const {
    completeAppointment,
    isCompleting,
    completeSuccess,
    getAppointments,
    fetchOverview,
    data,
    limit,
  } = props;
  const id = data && data.id;
  const history = useHistory();
  const type = useOverviewTypeContext();

  useEffect(
    () => {
      if (completeSuccess) {
        props.closeModal();
        if (history?.location?.pathname === "/appointment") {
          getAppointments(1, limit);
          return;
        }
        fetchOverview(type?.overviewType);
      }
    }, // eslint-disable-next-line
    [completeSuccess]
  );

  const changeStatus = (id) => {
    completeAppointment(id, "completed");
  };

  return (
    <DeleteModal
      displayModal={props.displayModal}
      closeModal={props.closeModal}
      title={"Complete this appointment?"}
      width={"463px"}
      text={"Complete"}
      onClick={() => changeStatus(id)}
      disabled={isCompleting}
      isLoading={isCompleting}
      loadingText={"Completing..."}
      children={
        "Once you complete this appointment, it won’t be possible to undo this action. Complete appointment?"
      }
      activate={true}
    />
  );
};

const mapStateToProps = (state) => ({
  isCompleting: state.userappointment.isChangingStatus,
  completeSuccess: state.userappointment.changeSuccess,
});

const mapDispatchToProps = (dispatch) => ({
  completeAppointment: (id, status) =>
    dispatch(changeUserAppointmentStatus(id, status)),
  getAppointments: (page, limit) => dispatch(getUserAppointments(page, limit)),
  fetchOverview: (queries) => dispatch(getOverview(queries)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompleteAppointment);
